import { ChangeDetectionStrategy, Component } from '@angular/core';
import { BackgroundPlayerComponent } from '@core';

@Component({
  selector: 'app-main',
  templateUrl: './main-page.component.html',
  styleUrls: ['./main-page.component.scss'],
  imports: [
    BackgroundPlayerComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MainPageComponent {}
